// extracted by mini-css-extract-plugin
export var searchHeader = "_9h-0";
export var searchHeaderDark = "_9h-1";